import { createStore, combineReducers, applyMiddleware, compose, Middleware, PreloadedState, StoreEnhancer } from 'redux';

import FormulaReducer from './Formula';

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION__?: (...args: any[]) => (next: any) => any;
    }
}

const rootReducer = combineReducers({
    formula: FormulaReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const thunkAlternative: Middleware = ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') return action({ dispatch, getState });
    return next(action);
};

export const getStore = (initialState?: PreloadedState<RootState>) =>
    createStore(
        rootReducer,
        initialState,
        compose(
            applyMiddleware(thunkAlternative),
            (typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
                ? window.__REDUX_DEVTOOLS_EXTENSION__()
                : (x: StoreEnhancer) => x) as StoreEnhancer,
        ),
    );

export const store = getStore();
